<template>
  <div>
    <a href="#"><span class="c-blue-text tw-underline" @click="dialog = true">EDIT QUOTE</span></a>
    <v-dialog v-model="dialog" max-width="1000px">
      <v-card class="tw-py-3 md:tw-py-8">
        <v-card-text>
          <h3 class="tw-text-xl md:tw-text-xl c-blue-text title-font tw-text-center">Choose who you wish to include in your cover</h3>
          <div class="tw-flex tw-justify-center">
            <StartHealth :is-edit="true" />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import StartHealth from '@/components/rfq/health/StartHealth';

export default {
  name: 'PersonalDetailsEdit',
  components: { StartHealth },
  data() {
    return {
      dialog: false,
    };
  },
  mounted() {
    this.$root.$on('health-edit-modal-closed', () => {
      this.dialog = false;
    });
  },
};
</script>
